import React from 'react';
import { orderStatusStyles } from '../utils/orders';
import type { OrderStatus } from '../types/platform';
export function OrderStatusBadge({
  status
}: {
  status: OrderStatus;
}) {
  return <span className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs ${orderStatusStyles[status]}`} data-id="element-80" data-mp="2kvxoa4h8hk7y">
      <span className="size-1.5 rounded-full bg-current" aria-hidden="true" data-id="element-81" data-mp="2pu8yigbfxwqp" />
      {status}
    </span>;
}